/**
 * Matches the three role landing routes. The Topbar uses this to decide
 * whether to hide its avatar block — on the role home that block is
 * replaced by `ProfileCardHero`, which carries its own copy of the user
 * menu so the user can still reach Mi cuenta / Cambiar contraseña / Cerrar
 * sesión.
 */
import { useLocation } from 'react-router';

import { VIEWS } from '@/config/views';

import type { ProfileCardVariant } from './ProfileCardHero';

const PATH_TO_VARIANT: Record<string, ProfileCardVariant | null> = {
  [VIEWS.dashboard.path]: 'executive',
  [VIEWS.hrHome.path]: 'hr',
  [VIEWS.employeeHome.path]: 'worker',
  [VIEWS.managerHome.path]: null,
};

/**
 * Returns the matching variant if `pathname` is a role-home index, otherwise
 * `null`. Only the role-home index counts: navigating to a sub-route of the
 * same hub must show the Topbar avatar again, the same way other authenticated
 * screens do.
 */
export function useIsRoleHome(): ProfileCardVariant | null {
  const { pathname } = useLocation();
  if (pathname in PATH_TO_VARIANT) return PATH_TO_VARIANT[pathname] ?? null;
  return null;
}
